import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes, FaMoneyBillWave } from 'react-icons/fa';

const CostsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          className="bg-white rounded-2xl p-6 max-w-lg w-full shadow-xl"
          onClick={e => e.stopPropagation()}
        >
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-2xl font-cursive text-gray-800 flex items-center gap-2">
              <FaMoneyBillWave className="text-[#D4AF37]" />
              Costos del Evento
            </h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <FaTimes className="text-xl" />
            </button>
          </div>

          <div className="space-y-6">
            <div className="border-b border-pink-200 pb-4">
              <h4 className="text-xl font-serif text-gray-700 mb-2">Día 1 - Fiesta Principal</h4>
              <p className="text-gray-600">Costo por persona tarjeta: $140,000</p>
              <p className="text-sm text-gray-500 mt-2">
                Incluye: Cena completa, bebidas y fiesta hasta el amanecer
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Precio valido hasta el 30 de Julio de 2025
              </p>
            </div>

            <div className="border-b border-pink-200 pb-4">
              <h4 className="text-xl font-serif text-gray-700 mb-2">Día 2 - Asado y Pileta</h4>
              <p className="text-gray-600">El almuerzo es a cargo de los novios</p>
              <p className="text-sm text-gray-500 mt-2">
                El invitado solo debera abonar el consumo de sus bebidas
              </p>
            </div>

            <div className="text-sm text-gray-500 italic">
              <p>* La tarifa sera actualizada mensualmente segun la variacion del indec</p>
            </div>
          </div>

          <div className="mt-6 flex justify-center">
            <button
              onClick={() => {
                const phoneNumber = "+543518589155";
                const message = `Hola! Que lindo que vamos a contar con tu presencia. 
La confirmacion se puede realizar en efectivo o por transferencia.
  - Alias: boda.pyj 
  - ⁠Titular: Jimena Nahir Salatin Geres 
  - ⁠CUIL:27378215558 
  - ⁠Cuenta: Naranja X

  Te esperamos`;
                const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                window.open(whatsappUrl, '_blank');
              }}
              className="bg-[#D4AF37] text-white px-8 py-3 rounded-full hover:bg-[#C5A028] transition-all duration-300 shadow-md border-2 border-[#FFD700] hover:border-[#D4AF37] font-cursive"
            >
              Confirmar Asistencia
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CostsModal; 